import { useDispatch, useSelector } from 'react-redux';
import { fetchLanguages } from './actions';

export function useLanguages() {
  const dispatch = useDispatch();
  const { loading, languages, error } = useSelector(state => state.languages);

  const getLanguages = (query = '', sortBy = 'name', sortDir = 'asc') => {
    dispatch(fetchLanguages(query, sortBy, sortDir));
  };

  return { loading, languages, error, getLanguages };
}